import { FuncResponse, FuncResponseType, FunctionBase } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { ErrorUtil } from "../../api/ErrorUtil";
import { Meta } from "../../cutil/Meta";
export class ImageSearchFunction extends FunctionBase {
    async run(input, identityInfo) {
        const res = await this.imageSearch(input, identityInfo);
        return new FuncResponse(FuncResponseType.IMAGE_TEXT, res);
    }
    async imageSearch(query, identityInfo) {
        const result = await this.brainClient.openAi.imageSearch(query, FunctionUtil.createAbortUuid(identityInfo));
        const images_results = result.data.images_results;
        if (images_results === undefined) {
            throw new Meta("ImageSearchFunction", ErrorUtil.defaultErrorMsg, "");
        }
        const imagesUrl = images_results.first().original || "";
        return imagesUrl;
    }
}
